import Image from "next/image";
import { memo } from "react";
const Benefits = ({ title, data }) => (
  <div className="text-center py-16 lg:px-10 justify-center md:justify-start w-full">
    <h2 className="text-black text-4xl md:text-6xl font-medium mb-2 text-left md:text-center px-4 md:px-0">
      <span>{title ?? "Values We Bring To Your Project"}</span>
    </h2>
    <div className="flex flex-wrap mt-12 xl:mt-24 sixPartsRow">
      {data.map((element) => (
        <div
          key={element.title}
          className="w-1/2 md:w-4/12 py-6 px-4 md:p-8 xl:p-12 text-left"
        >
          <Image
            alt={element.alt}
            className="w-11 h-11 ml-0 md:w-auto md:h-auto"
            height={50}
            objectFit="contain"
            src={element.image}
            title={element.title}
            width={50}
          />
          <h3 className="font-medium text-sm md:text-2xl text-primary-black pt-4 mb-2 w-3/4 md:w-full min-h-14">
            <span>{element.title}</span>
          </h3>
          <p className="[&>a]:text-blue-500 font-light text-base text-black pt-3">
            <span
              dangerouslySetInnerHTML={{ __html: element.description }}
            ></span>
          </p>
        </div>
      ))}
    </div>
  </div>
);

export default memo(Benefits);
